import TripFormModalView from '../../trips/scripts/trip_form_modal_view';

export default class UserFormView {
  constructor() {
    this.observeDriverCreateClick();
  }

  observeDriverCreateClick() {
    $("form.user_form").on("click", "button.new_driver", (event) => {
      console.log("New Driver button was clicked")
      const href = $(event.currentTarget).attr("href")

      this.modalView = new TripFormModalView({
        parentView:       this,
        url:              href,
        title:            "Add New Driver",
        submitButtonText: "Create Driver",
      })
    })
  }

  formDidSubmitSuccessfully(status, data) {
    console.log("UserFormView#formDidSubmitSuccessfully", status, data)

    if (status == 201) {
      $("#user_driver_lookup").val(data.driver.to_select_option)
      $("#driver_id").val(data.driver.id)
    }
  }
}
